<template>
    <div class="upload">
        <navTop :isLogin="1" title="相君科技平台用户首页"></navTop>
        <div class="all">
            <div class="sign">
                <div class="pic">
                    <pdf ref="pdf" :src="$global.Local + $route.params.path" :page="pageNum" :rotate="pageRotate"
                         @password="password" @progress="loadedRatio = $event"
                         @page-loaded="pageLoaded($event)" @num-pages="pageTotalNum=$event" @error="pdfError($event)"
                         @link-clicked="page = $event">
                    </pdf>
                    <div class="pdf-tab">
                        <div class="btn-def" @click.stop="prePage">上一页</div>
                        <div class="btn-pre">{{pageNum}}/{{pageTotalNum}}</div>
                        <div class="btn-def" @click.stop="nextPage">下一页</div>
                    </div>
                </div>
                <div class="result">
                    <div class="title">检验结果</div>
                    <div class="content">
                        <div class="left">
                            <div class="message">是否为本平台电子签章</div>
                            <div class="message">电子印章出处</div>
                            <div class="message">印章类型</div>
                            <!-- <div class="message">签署时间</div> -->
                            <div class="message">检验时间</div>
                            <div class="message">证书是否合格</div>
                        </div>
                        <div class="right">
                            <div class="apect">
                                {{checkData.ou == true ? '是' : '否'}}
                                <!-- <img src="../../../../static/img/pass.png" /> -->
                            </div>
                            <div class="apect">
                                {{checkData.ou == true ? '相君电子印章平台电子印章' : '其他平台'}}
                            </div>
                            <div class="apect">{{type(checkData.type)}}</div>
                            <div class="apect"> {{checkData.time}}</div>
                            <!-- <div class="apect">2021/03/12</div> -->
                            <div class="apect">{{checkData.isPass == true ? '是' : '否'}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <navBom></navBom>
    </div>
</template>

<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'
    import pdf from 'vue-pdf'

    export default {
        components: {
            navTop,
            navBom,
            pdf
        },
        data() {
            return {
                pdfUrl: "http://47.108.75.235:5389/CM-API//upload/2021-04-13/fd6231dde90c4c789b1d4f557cb89cf4.pdf",
                pageNum: 1,
                pageTotalNum: 1,
                pageRotate: 0,
                // 加载进度
                loadedRatio: 0,
                curPageNum: 0,
                checkData: []
            }
        },
        mounted() {
            if (!this.$route.params.path) {
                this.$message.info('此合同没有pdf文件');
                this.$router.push('signInsp');
            } else {
                this.getData(this.$route.params.id);
            }
        },
        methods: {
            type(e) {
                if (e == 1) {
                    return '个人'
                } else if (e == 2) {
                    return '企业'
                } else {
                    return '其他'
                }
            },
            getData(id) {
                let _this = this;
                let param = new FormData();
                param.append('id', id);
                param.append('token', _this.$global.token);
                _this.api.checkContact(param).then(res => {
                    console.log(res, "检验结果")
                    _this.checkData = res.data
                })
            },
            prePage() {
                var p = this.pageNum
                p = p > 1 ? p - 1 : this.pageTotalNum
                this.pageNum = p
            },
            nextPage() {
                var p = this.pageNum
                p = p < this.pageTotalNum ? p + 1 : 1
                this.pageNum = p
            },
            clock() {
                this.pageRotate += 90
            },
            counterClock() {
                this.pageRotate -= 90
            },
            password(updatePassword, reason) {
                updatePassword(prompt('password is "123456"'))
                console.log('...reason...')
                console.log(reason)
                console.log('...reason...')
            },
            pageLoaded(e) {
                this.curPageNum = e
            },
            pdfError(error) {
                console.error(error)
            },
            pdfPrintAll() {
                this.$refs.pdf.print()
            },
            pdfPrint() {
                this.$refs.pdf.print(100, [1, 2])
            },
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .upload {
        width: @a;
        height: auto;

        .all {
            width: @a;
            height: auto;
            display: @flex;
            justify-content: center;
            padding: 2% 0;

            .sign {
                width: 1500px;
                height: auto;
                padding: 10px;
                display: @flex;

                .pic {
                    width: 768px;
                    height: auto;
                    border: solid 1px #aaaaaa;
                    padding: 2px;

                    .pdf-tab {
                        width: 100%;
                        height: 100px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .btn-def {
                            width: 100px;
                            height: 40px;
                            line-height: 40px;
                            text-align: center;
                            background-image: linear-gradient(270deg,
                            #1e6eee 0%,
                            #109ee7 50%,
                            #01cee0 100%),
                            linear-gradient(#000000,
                            #000000);
                            background-blend-mode: normal,
                            normal;
                            color: #fff;
                            font-size: 24px;
                            cursor: pointer;
                        }

                        .btn-pre {
                            width: 100px;
                            height: 40px;
                            line-height: 40px;
                            text-align: center;
                            font-size: 24px;

                            border: solid 0.013333rem #aaaaaa;
                            margin: 0 20px;
                        }
                    }
                }

                .result {
                    width: 660px;
                    height: 520px;
                    margin-left: 50px;

                    .title {
                        width: 660px;
                        height: 50px;
                        line-height: 50px;
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal,
                        normal;
                        color: #fff;
                        font-size: 24px;
                        padding-left: 22px;
                    }

                    .content {
                        width: 660px;
                        height: 470px;
                        background-image: url(../../../../static/img/result.png);
                        background-size: 100% 100%;
                        background-blend-mode: normal,
                        normal;
                        opacity: 0.8;
                        display: @flex;
                        align-items: center;
                        justify-content: center;

                        .left {
                            width: 210px;
                            height: 400px;
                            display: @flex;
                            flex-direction: column;
                            justify-content: space-around;
                            align-items: center;
                        }

                        .right {
                            width: 260px;
                            height: 400px;
                            margin-left: 36px;
                            display: @flex;
                            flex-direction: column;
                            justify-content: space-around;
                            align-items: center;
                        }

                        .message {
                            font-size: 20px;
                            letter-spacing: 1px;
                            color: #ffffff;
                            width: @a;
                            height: auto;
                            text-align: end;
                        }

                        .apect {
                            font-size: 18px;
                            letter-spacing: 1px;
                            color: #ffffff;
                            width: @a;
                            height: auto;
                            display: @flex;
                            justify-content: flex-start;

                            img {
                                width: 25px;
                                height: 25px;
                                margin-left: 10px;
                            }
                        }
                    }
                }
            }

        }

    }
</style>



// WEBPACK FOOTER //
// src/components/page/signature/upload_insp.vue